// A file name is sent to /uploads/buffer in the x-file-name header, and the
// browser refuses to send a header holding anything outside Latin-1 — the
// request then fails before it leaves the page. macOS screenshot names hit
// this ("… at 4.52.10 PM.png" has a narrow no-break space before PM), as do
// names in Hindi or other scripts. Reduce the name to printable ASCII.
export const headerSafeFileName = (name, fallback = `upload-${Date.now()}.jpg`) => {
  const ascii = String(name || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')   // drop accents left over from NFKD
    .replace(/[^\x20-\x7E]/g, '_')     // anything else non-ASCII
    .replace(/\s+/g, ' ')
    .trim();
  // A name made only of replacements ("____.pdf") carries no information —
  // use the fallback, but keep the real extension (it decides how it's shown).
  if (/[A-Za-z0-9]/.test(ascii.replace(/\.[^.]*$/, ''))) return ascii;
  const ext = (ascii.match(/\.[A-Za-z0-9]{1,5}$/) || [])[0];
  return ext ? fallback.replace(/(\.[^.]*)?$/, ext) : fallback;
};
